import React, { useEffect } from 'react'
import { Collapsible, CollapsibleContent } from '@/Components/ui/collapsible'
import { useSidebar, SidebarGroup, SidebarGroupContent, SidebarMenu, SidebarMenuSub } from '@/Components/ui/sidebar'
import ParentLabel from './ParentLabel'
import ChildLabel from './ChildLabel'
import { useAuth } from '@/Context/AuthContext'
import { checkPermission } from '@/utils/helper'
import AccessDenied from '../Common/AccessDenied'

const SidebarItems = ({ items, userInfo }) => {
    return (
        <SidebarGroup>
            <SidebarMenu>
                {items.map((item) => {
                    if (!checkPermission(item.permission, userInfo?.roles ?? [])) {
                        return null
                    }
                    return (
                        <Collapsible key={item.title} title={item.title} className="group/collapsible">
                            <SidebarGroup className="p-0">
                                <ParentLabel item={item} />
                                <CollapsibleContent>
                                    <SidebarGroupContent>
                                        {item.items?.length ? (
                                            <SidebarMenuSub>
                                                {item.items.map((item) => (
                                                    <ChildLabel key={item.title} item={item} />
                                                ))}
                                            </SidebarMenuSub>
                                        ) : null}
                                    </SidebarGroupContent>
                                </CollapsibleContent>
                            </SidebarGroup>
                        </Collapsible>
                    )
                })}
            </SidebarMenu>
        </SidebarGroup>
    )
}

export default SidebarItems
